export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/08c48a46101cc42aed10d212d387a250.jpg"
          alt="Luxury Products by Maram"
          className="w-full h-full object-cover object-top animate-ken-burns"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in-down" style={{ fontFamily: "'Playfair Display', serif" }}>
          Luxury Products by Maram
        </h1>
        <div className="space-y-3 mb-8">
          <p className="text-xl md:text-2xl text-white font-light animate-fade-in-up" style={{ animationDelay: '300ms' }}>
            اختيار شخصي لقطع فاخرة
          </p>
          <p className="text-lg md:text-xl text-white/90 font-light animate-fade-in-up" style={{ animationDelay: '500ms' }}>
            أختارها بذوقي… وأقدّمها بثقة
          </p>
        </div>
        <button
          onClick={() => scrollToSection('categories')}
          className="bg-[#D4AF7A] text-white px-10 py-4 rounded-full text-lg hover:bg-[#C9A88A] transition-all duration-300 cursor-pointer whitespace-nowrap font-medium shadow-lg hover:shadow-xl transform hover:scale-105 animate-fade-in-up"
          style={{ animationDelay: '700ms' }}
        >
          اكتشفي المجموعة
        </button>
      </div>

      <style>{`
        @keyframes ken-burns {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.1);
          }
        }

        @keyframes fade-in-down {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-ken-burns {
          animation: ken-burns 20s ease-out infinite alternate;
        }

        .animate-fade-in-down {
          animation: fade-in-down 1s ease-out forwards;
        }

        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </section>
  );
}
